export default __webpack_public_path__ + "static/kate-94d08d3c9c42c3b109eb72e8784ec643.jpg";